// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebGraphql_Shifts = require("../../graphql/WebGraphql_Shifts.bs.js");
var WebStore_ThunkHelpers = require("../WebStore_ThunkHelpers.bs.js");
var WebStore_Types_Action = require("../WebStore_Types_Action.bs.js");

function commentOnShift(shift, comment) {
  return {
          TAG: /* SideEffects */1,
          _0: Curry._3(WebStore_ThunkHelpers.runAsyncMutation, undefined, (function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.updateShift, WebStore_Types_Action.dashboard, param);
                }), Curry._1(WebGraphql_Shifts.CommentOnShift.mutateStoreError, {
                    shift: shift,
                    comment: comment
                  }))
        };
}

function reviewWorker(workerShiftId, rating) {
  return {
          TAG: /* SideEffects */1,
          _0: Curry._3(WebStore_ThunkHelpers.runAsyncMutation, /* NotRequired */1, (function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.updateShift, WebStore_Types_Action.dashboard, param);
                }), Curry._1(WebGraphql_Shifts.ReviewWorker.mutateStoreError, {
                    rating: rating,
                    workerShiftId: workerShiftId
                  }))
        };
}

function fetchEditingShiftById(id) {
  return {
          TAG: /* SideEffects */1,
          _0: Curry._3(WebStore_ThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.updateEditingShift, Curry._1(WebGraphql_Shifts.GetShiftById.queryAsyncResult, id))
        };
}

var SideEffects = {
  commentOnShift: commentOnShift,
  reviewWorker: reviewWorker,
  fetchEditingShiftById: fetchEditingShiftById
};

function updateEditingShift(state, editingShift) {
  return Curry._4(WebStore_ThunkHelpers.updateAsyncResult, (function (param) {
                return param.editingShift;
              }), (function (state, editingShift) {
                return {
                        cities: state.cities,
                        currentUser: state.currentUser,
                        dashboard: state.dashboard,
                        editingShift: editingShift,
                        layout: state.layout,
                        postAShift: state.postAShift,
                        savedBusinessAdmins: state.savedBusinessAdmins,
                        savedBusinessManagers: state.savedBusinessManagers,
                        savedLocations: state.savedLocations,
                        token: state.token,
                        timing: state.timing,
                        view: state.view
                      };
              }), state, editingShift);
}

var Pure = {
  updateEditingShift: updateEditingShift
};

exports.SideEffects = SideEffects;
exports.Pure = Pure;
/* Relude_Globals Not a pure module */
